import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import casoVideoMp4 from "../../assets/videos/presentacion-caso-sc1-intro.mp4";
import casoVideoWebm from "../../assets/videos/presentacion-caso-sc1-intro.webm";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import { IconRotateClockwise } from "@tabler/icons-react";
import "../StartGame.css";
import "./Scenario1Intro.css";
import { scenario1ProceedToScenariosBoard } from "./scenario1ProceedToScenariosBoard";

export default function Scenario1Intro() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const handleContinue = async () => {
		if (loading) return;
		setLoading(true);
		try {
			const ok = await scenario1ProceedToScenariosBoard({ game, group });
			if (ok) {
				navigate(ROUTES.TRANSITION_SCENARIOS, {
					state: { activeScenario: 2 },
				});
			}
		} finally {
			setLoading(false);
		}
	};

	const handleReplayFromStart = () => {
		const el = videoRef.current;
		if (!el) return;
		el.currentTime = 0;
		el.play().catch(() => {});
	};

	return (
		<div className="s1-intro-page">
			<div className="s1-intro-inner">
				<span className="start-game-badge s1-intro-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Presentación del caso
				</span>

				<header className="s1-intro-head">
					<h1 className="s1-intro-title">
						<span>Presentación</span> del caso
					</h1>
				</header>

				<div className="s1-intro-video-frame">
					<video
						ref={videoRef}
						autoPlay
						muted={!canPlayWithSound}
						playsInline
						preload="metadata"
						aria-label="Presentación del paciente"
					>
						<source src={casoVideoWebm} type="video/webm" />
						<source src={casoVideoMp4} type="video/mp4" />
					</video>
				</div>

				<div className="s1-intro-footer">
					<button
						type="button"
						className="s1-intro-replay s1-intro-replay--icon"
						aria-label="Volver a reproducir el vídeo desde el principio"
						onClick={(e) => {
							e.preventDefault();
							handleReplayFromStart();
						}}
					>
						<IconRotateClockwise size={22} stroke={1.75} aria-hidden />
					</button>
					<button
						type="button"
						className="start-game-cta s1-intro-cta"
						disabled={loading}
						aria-busy={loading}
						onClick={(e) => {
							e.preventDefault();
							handleContinue();
						}}
					>
						{loading ? (
							<span className="start-game-cta-spinner" aria-hidden />
						) : (
							<img className="start-game-cta-icon" src={flechaAvanzar} alt="" />
						)}
						{loading ? "Cargando…" : "Continuar"}
					</button>
				</div>
			</div>
		</div>
	);
}
